import { connect } from 'react-redux'
import { CreateHocLazy, EmptyComponent } from '@lib/ReduxBase'
import { ICategoryDetailOtherProps } from './types'
import { ICategoryDetailReduxProps } from './redux.types'
import { mapDispatchToProps, mapStateToProps } from './redux.map'
import CategorySelectMultiple from './CategorySelectMultiple'

export * from './redux.thunks'
export { default as CategoryDetailSlice } from './redux.slice'

const HocLazyInsatnce = CreateHocLazy<ICategoryDetailReduxProps, ICategoryDetailOtherProps>(CategorySelectMultiple, { LazySpinner: EmptyComponent })
export const CategorySelectMultipleMapRedux = connect(mapStateToProps, mapDispatchToProps)(HocLazyInsatnce)
